var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileStat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1166 18.0167C14.3833 18.2333 13.5166 18.3333 12.5 18.3333H7.49997C6.4833 18.3333 5.61663 18.2333 4.8833 18.0167C5.06663 15.85 7.29163 14.1416 9.99997 14.1416C12.7083 14.1416 14.9333 15.85 15.1166 18.0167Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4998 1.66667H7.49984C3.33317 1.66667 1.6665 3.33333 1.6665 7.5V12.5C1.6665 15.65 2.6165 17.375 4.88317 18.0167C5.0665 15.85 7.2915 14.1416 9.99984 14.1416C12.7082 14.1416 14.9332 15.85 15.1165 18.0167C17.3832 17.375 18.3332 15.65 18.3332 12.5V7.5C18.3332 3.33333 16.6665 1.66667 12.4998 1.66667ZM9.99984 11.8083C8.34984 11.8083 7.0165 10.4667 7.0165 8.81668C7.0165 7.16668 8.34984 5.83333 9.99984 5.83333C11.6498 5.83333 12.9832 7.16668 12.9832 8.81668C12.9832 10.4667 11.6498 11.8083 9.99984 11.8083Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9833 8.81668C12.9833 10.4667 11.6499 11.8083 9.99994 11.8083C8.34994 11.8083 7.0166 10.4667 7.0166 8.81668C7.0166 7.16668 8.34994 5.83333 9.99994 5.83333C11.6499 5.83333 12.9833 7.16668 12.9833 8.81668Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileStat);
export default __webpack_public_path__ + "static/media/profile-stat.1cc786b7ed31172de92096bbdd52bff8.svg";
export { ForwardRef as ReactComponent };